"use strict";

exports.__esModule = true;
var _AIChatDialog = require("./AIChatDialog");
Object.keys(_AIChatDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AIChatDialog[key]) return;
  exports[key] = _AIChatDialog[key];
});
var _AIChatContext = require("./AIChatContext");
Object.keys(_AIChatContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AIChatContext[key]) return;
  exports[key] = _AIChatContext[key];
});